import ClientIdType from 'owa-service/lib/contract/ClientIdType';
import EntityType from 'owa-service/lib/contract/EntityType';
import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';

/*
 * Invokes createFindPeopleFeedbackManager.
 */
export default function createFindPeopleFeedbackManager(): FeedbackManagerState {
    return {
        maxActionBatchSize: 10,
        entityType: EntityType.People,
        entityScenarioName: 'FindPeople_react',
        hasSessionStarted: false,
        isSessionPaused: false,
        entityFeedbackEntries: [],
        clientSessionId: '',
        clientVersion: '1.0',
        clientId: ClientIdType.Web,
        entrySequenceNumber: 0,
    } as FeedbackManagerState;
}
